/** Textes « planning » — le français fait foi. */
export const planning = {
  couches: {
    loue: 'Louée', reserve: 'Réservée', dispo: 'Disponible',
    retard: 'En retard', entretien: 'Entretien', trou: 'Trou à vendre',
  } as Record<string, string>,
  aides: {
    retard: 'sinon compté comme louée',
    entretien: 'sinon compté comme réservée',
    trou: 'les jours creux entre deux locations',
  } as Record<string, string | undefined>,
  appeler: (client: string | undefined) => `Appeler ${client ?? 'le client'}`,
  paye: 'payé',
  impaye: 'non payé',
  titre: 'Planning',
  vehicules: (n: number) => `${n} véhicule(s) ·`,
  deA: (a: string, b: string) => `de ${a} à ${b}`,
  selectionnees: (n: number) => ` · ${n} voiture(s) sélectionnée(s)`,
  ceMois: 'Ce mois-ci',
  mois: (n: number) => `${n} mois`,
  nVoitures: (n: number) => `${n} voiture(s)`,
  choisirVoitures: 'Choisir les voitures',
  masquerQuadrillage: 'Masquer le quadrillage des jours',
  afficherQuadrillage: 'Afficher le quadrillage des jours',
  masquerGrillage: 'Masquer le grillage',
  afficherGrillage: 'Afficher le grillage',
  couleurs: 'Couleurs',
  voituresAffichees: 'Voitures affichées',
  toutes: 'Toutes',
  fermer: 'Fermer',
  aucuneCoche: 'Aucune coche = toutes les voitures. Votre choix est conservé pour la prochaine fois.',
  couleursPlanning: 'Couleurs du planning',
  retablir: 'Rétablir',
  couleursExplication: "Trois couleurs par défaut — louée, réservée, disponible. Les autres s'allument si vous le voulez. Une couche éteinte ne cache jamais une voiture occupée : elle reprend simplement une des trois couleurs de base.",
  couleurDe: (label: string) => `Couleur — ${label}`,
  toujours: 'toujours',
  afficherCouche: (label: string) => `Afficher ${label}`,
  trousTitre: (n: number, m: string) => `${n} trou(s) dans le planning — ${m} d'argent qui dort`,
  trousA: (n: number) => `${n} journée(s) où une voiture est immobile `,
  entreDeux: 'entre deux locations',
  trousB: '. Elles sont hachurées en orange ci-dessous : la voiture est déjà là, déjà préparée.',
  vehicule: 'Véhicule',
  trouTitre: (n: number, m: string) => `${n} jour(s) libres entre deux locations — ${m} à vendre`,
  ouvrirDossier: (ref: string) => `Ouvrir le dossier ${ref}`,
  preparation: (min: number) => `Préparation — ${min} min avant la prochaine sortie`,
  duAu: (a: string, b: string) => `Du ${a} au ${b}`,
  effacer: 'Effacer',
  parJour: (m: string) => `${m}/j`,
  cliquezVoiture: 'Cliquez une voiture pour ouvrir une nouvelle location déjà remplie avec ces dates.',
  libreLe: (d: string) => ` · libre le ${d}`,
  glissez: 'Glissez sur le planning',
  aideBas: " pour voir ce qui est libre sur une période. Le rouge n'est pas une erreur : c'est une journée où la voiture ne rapporte rien. Une voiture qui rentre à 11 h n'est pas libre à 11 h — la fin hachurée de chaque barre est le temps de préparation, et il n'est pas réservable.",
};
